/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { seedersControllerAnaliticas } from '../fn/seeders/seeders-controller-analiticas';
import { SeedersControllerAnaliticas$Params } from '../fn/seeders/seeders-controller-analiticas';
import { seedersControllerParametros } from '../fn/seeders/seeders-controller-parametros';
import { SeedersControllerParametros$Params } from '../fn/seeders/seeders-controller-parametros';

@Injectable({ providedIn: 'root' })
export class SeedersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `seedersControllerAnaliticas()` */
  static readonly SeedersControllerAnaliticasPath = '/api/seeders/analiticas';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `seedersControllerAnaliticas()` instead.
   *
   * This method doesn't expect any request body.
   */
  seedersControllerAnaliticas$Response(params?: SeedersControllerAnaliticas$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return seedersControllerAnaliticas(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `seedersControllerAnaliticas$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  seedersControllerAnaliticas(params?: SeedersControllerAnaliticas$Params, context?: HttpContext): Observable<void> {
    return this.seedersControllerAnaliticas$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `seedersControllerParametros()` */
  static readonly SeedersControllerParametrosPath = '/api/seeders/parametros';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `seedersControllerParametros()` instead.
   *
   * This method doesn't expect any request body.
   */
  seedersControllerParametros$Response(params?: SeedersControllerParametros$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return seedersControllerParametros(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `seedersControllerParametros$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  seedersControllerParametros(params?: SeedersControllerParametros$Params, context?: HttpContext): Observable<void> {
    return this.seedersControllerParametros$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
